// A tiny media fragment lets Safari decode the opening frame without playback.
export default function videoPreviewUrl(url) {
  if (!url || url.includes('#')) return url

  return `${url}#t=0.001`
}

// Persisted posters use the same owner-scoped key as the original video.
export function videoPosterUrl(url) {
  if (!url || url.includes('?')) return undefined

  return `${url.split('#')[0]}.poster.jpg`
}
